var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18.7 8.8c0 1.25.34 2 1.07 2.85.55.62.73 1.43.73 2.3 0 .88-.29 1.71-.86 2.38a4.54 4.54 0 0 1-2.9 1.42c-1.57.13-3.15.24-4.74.24-1.6 0-3.16-.06-4.74-.24a4.53 4.53 0 0 1-2.9-1.42 3.62 3.62 0 0 1-.86-2.37c0-.88.18-1.69.73-2.31A3.8 3.8 0 0 0 5.29 8.8v-.43c0-1.68.42-2.78 1.29-3.86A7.07 7.07 0 0 1 11.96 2h.09c2.08 0 4.2.99 5.46 2.62a5.54 5.54 0 0 1 1.2 3.75v.43ZM9.08 20.06c0-.5.47-.73.9-.83.5-.1 3.54-.1 4.04 0 .43.1.89.33.89.83-.03.48-.3.9-.7 1.18a3.63 3.63 0 0 1-2.72.73 3.62 3.62 0 0 1-1.71-.74c-.39-.26-.67-.69-.7-1.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell24);
export default __webpack_public_path__ + "static/media/bell-24.2879c15e0835ec341eb50692dbcf54b9.svg";
export { ForwardRef as ReactComponent };